import type { GlobalShortcutsItem } from '@atlassian/global-shortcuts';
import { L1_MENU_GROUPS } from '@atlassian/navigation-common';
import type { ItemDragAndDropGroup } from '@atlassian/navigation-drag-and-drop';

import type { NavItemConfig, NavItemConfigInternal, ShortcutsConfig } from '../../types';
import { getMenuIds } from '../get-menu-ids';
import { partitionByReorderable } from '../partition-by-reorderable';

// NavItem or ShortcutItem
export const getMenuIdsByReorderable = ({
	allItems,
	shortcuts,
	group,
}: {
	allItems: Record<string, Partial<NavItemConfigInternal>>;
	group?: ItemDragAndDropGroup;
	shortcuts: ShortcutsConfig;
}) => {
	const transformedItems = Object.entries(allItems).map(([key, value]) => {
		return {
			menuId: key,
			...(value as NavItemConfig),
			// Default to true if isReorderable is undefined
			isReorderable: value?.isReorderable ?? true,
			group: L1_MENU_GROUPS.MENU,
		};
	});

	const transformedShortcutItems = Object.entries(shortcuts).map(([key, value]) => {
		return {
			menuId: key,
			...(value as GlobalShortcutsItem),
			// Default to true if isReorderable is undefined
			isReorderable: value?.isReorderable ?? true,
			group: L1_MENU_GROUPS.SHORTCUTS,
		};
	});

	const filtered = [...transformedItems, ...transformedShortcutItems].filter(
		(item) => item.group === group || group === undefined,
	);

	return partitionByReorderable(filtered).map(getMenuIds) as [string[], string[]];
};
